import { AnimatePresence, motion } from 'framer-motion'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import Skeleton from 'react-loading-skeleton'

const FleetsCardsLayout = ({ isHideTabs, isShowRate = false, item, index, activeTab, changeCurrLoading, isHourlyRate = false, isDailyRate = false }) => {
  const t = useTranslations('')
  return (
    <div className="">
      <div className=" bg-[#FBFBFB] min-h-[270px]  box-car-shadow flex flex-col font-light items-center shadow-[0px_1px_2px_1px_rgba(0_0_0/0.1)] m-2 px-6 py-[30px] ">
        <div className="min-h-[104.5px] flex w-full justify-center items-end mb-[15px]">
          <Image
            src={item.img}
            className="max-w-full size-auto w-full mix-blend-multiply"
            alt="Rolzo Fleet"
            width={209}
            height={105}
            loading='eager'
          />
        </div>
        <small className="text-rolzo-grey text-[12px] uppercase mb-[9px]"
        >{t.has(`all-fleet-types.${item.type}`) ? t(`all-fleet-types.${item.type}`) : item.type}</small>
        <h6 className="text-[#212529] whitespace-nowrap overflow-hidden text-ellipsis mb-[9px] max-w-full">{t.has(`vehiclesFullNames.${item.name}`) ? t(`vehiclesFullNames.${item.name}`) : item.name}</h6>
        {isShowRate &&
          (!changeCurrLoading ? (
            <small
              key={`${item.id}-${item.currency}`}
              className={`text-rolzo-grey text-[14px] capitalize mb-2`}
            >
              {t('common.from')} {item.fare} {item.currency}<span className='normal-case'>{isHourlyRate ? `/${t('common.per_hour')}` : isDailyRate ? `/${t('common.per_day')}` : ''}</span>
            </small>
          ) : (
            <small
              className={`text-rolzo-grey text-[14px] capitalize mb-2 opacity-1`}
            >
              <Skeleton
                width={93}
                height={15}
                className={` w-full h-full text-[14px]`}
              />
            </small>
          ))
        }
        {isHideTabs ?
          <div className={`${item.isElectric || item.cat === "electric" ? 'visible' : 'invisible'}`}>
            <Image
              width={12}
              height={12}
              className='w-auto h-3'
              src="https://storage.googleapis.com/rolzo-static-bucket/images/ROLZO_Leaf_badge_Positive_Green.png"
              alt="Rolzo Booking"
            />
          </div>
          :
          activeTab.key === "Electric" &&
          <Image
            width={12}
            height={12}
            className='w-auto h-3'
            src="https://storage.googleapis.com/rolzo-static-bucket/images/ROLZO_Leaf_badge_Positive_Green.png"
            alt="Rolzo Booking"
          />
        }
      </div>
    </div>
  )
}

export default FleetsCardsLayout